/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.role-text[_ngcontent-%COMP%] {\n	width: 5rem;\n	margin-left: 0.5rem;\n	margin-right: 0.5rem;\n}\n\n.role-row[_ngcontent-%COMP%] {\n	display: -webkit-box;\n	display: -ms-flexbox;\n	display: flex;\n	-webkit-box-align: center;\n	    -ms-flex-align: center;\n	        align-items: center;\n	-webkit-box-pack: start;\n	    -ms-flex-pack: start;\n	        justify-content: flex-start;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Vzci9zcmMvYXBwL3NyYy9hcHAvY29tcG9uZW50cy9wYWdlcy91c2VyL3VzZXItZWRpdC91c2VyLWVkaXQuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy91c3Ivc3JjL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvcGFnZXMvdXNlci91c2VyLWVkaXQvdXNlci1lZGl0LmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/pages/user/user-edit/user-edit.component.css.shim.ngstyle.ts